import { render, staticRenderFns } from "./users-report.vue?vue&type=template&id=28fa951e&scoped=true&"
import script from "./users-report.vue?vue&type=script&lang=js&"
export * from "./users-report.vue?vue&type=script&lang=js&"
import style0 from "./users-report.vue?vue&type=style&index=0&id=28fa951e&lang=scss&scoped=true&"
import style1 from "./users-report.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa951e",
  null
  
)

export default component.exports